import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import ThemesGrid from '../components/themes-grid';

const TumblrThemes = ({ data }) => (
  <ThemesGrid
    themes={data.allMarkdownRemark.edges}
    title={'Lovingly crafted Tumblr themes for you.'}
    titleWordsWrap={3}
    comingSoon={true}
  >
    <Helmet>
      <title>{'The Best-Designed Tumblr Themes for Bloggers and Creatives'}</title>
      <meta
        name="description"
        content={
          'Download the most beautiful and effective Tumblr themes for photographers, designers, illustrators, bloggers, and creatives.'
        }
      />
    </Helmet>
  </ThemesGrid>
);

TumblrThemes.propTypes = {
  data: PropTypes.object,
};

export default TumblrThemes;

export const query = graphql`
  query TumblrThemesQuery {
    allMarkdownRemark(
      filter: {
        fields: { instanceName: { eq: "theme" } }
        frontmatter: { platform: { eq: "tumblr" } }
      }
      sort: { fields: [fields___created], order: DESC }
    ) {
      edges {
        node {
          ...themePreview_details
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/tumblr-themes.js